import { Button } from "@ui/Button"
import { Input } from "@ui/Input"

export default function TimeRangeInput({ start, end: endTime, onChange, onRemove }) {
  return (
    <div className="flex items-center gap-2">
      <Input
        type="time"
        value={start}
        onChange={(e) => onChange({ start: e.target.value, end: endTime })}
        className="w-auto"
      />
      <span className="text-webex-gray-500 dark:text-webex-gray-400">to</span>
      <Input
        type="time"
        value={endTime}
        onChange={(e) => onChange({ start, end: e.target.value })}
        className="w-auto"
      />
      {onRemove && (
        <Button variant="text" onClick={onRemove}>
          Remove
        </Button>
      )}
    </div>
  )
}
